import ComponentManager from "../../componentFramework";

/**
 * This backs the edit.html view.
 */
@ComponentManager.register()
export default class SiteEditor {
	public static componentStyleClass = "fullscreenButton";

	constructor(private readonly rootElement: HTMLElement) {
		rootElement.addEventListener("click", this.onClick);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.rootElement.removeEventListener("click", this.onClick);
	}

	private readonly onClick = (ev: MouseEvent) => {
		ev.preventDefault();
		const selector = this.rootElement.getAttribute("data-fullscreen-root-selector");
		if (selector !== null) {
			const mainPanel = document.querySelector(selector);
			if (mainPanel !== null) {
				mainPanel.classList.toggle("isFullscreen");
			}
		}
	}
}
